import extend from '@/utils/vuex-extend';
import {table} from '@/vuex-extend';
import {fetchList} from '@/api/oms/return-order';
import {wait} from '@/utils/wait';
import moment from "moment";

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {}
	},
	actions: {
		async getList({state, dispatch}, payload) {
			await wait(dispatch, 'oms.return.order.list', async function () {
				let {searchForm} = state;
				await dispatch('getData', {
					caller: fetchList,
					options: {
						orderSn: searchForm.orderSn,
						searchReturnStatus: searchForm.searchReturnStatus,
						returnType: searchForm.returnType,
						returnSerialNumber: searchForm.returnSerialNumber,
						applyTimeStart: searchForm.time && moment(moment(searchForm.time[0]).format('YYYY-MM-DD')).valueOf() / 1000,
						applyTimeEnd: searchForm.time && moment(moment(searchForm.time[1]).format('YYYY-MM-DD')).valueOf() / 1000,
						...payload
					}
				});
			})
		},
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/oms/return-order/list.js